import { render, staticRenderFns } from "./IncomingTenderListFooter.vue?vue&type=template&id=3ba75aab&"
import script from "./IncomingTenderListFooter.vue?vue&type=script&lang=js&"
export * from "./IncomingTenderListFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports